// extracted by mini-css-extract-plugin
export default {"form":"ProvisionVoCAccount_form__GuasQ","inputField":"ProvisionVoCAccount_inputField__4lD4B","createButton":"ProvisionVoCAccount_createButton__ycf6+"};